import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const IMG = (name) => `/gen/${name}.png`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    timeout: 120000,
});

export async function getConfig() {
    const { data } = await api.get("/config");
    return data;
}

export async function getDailyLimit() {
    const { data } = await api.get("/daily-limit");
    return data;
}

export async function getSampleReport() {
    const { data } = await api.get("/sample-report");
    return data;
}

export async function getAnalysis(id) {
    const { data } = await api.get(`/analysis/${id}`);
    return data;
}

export async function createOrder(analysis_id, pack_size = null, selected_event_indices = null) {
    const body = { analysis_id };
    if (pack_size) body.pack_size = pack_size;
    if (Array.isArray(selected_event_indices)) body.selected_event_indices = selected_event_indices;
    const { data } = await api.post("/payment/create-order", body);
    return data;
}

export async function verifyPayment(payload) {
    const { data } = await api.post("/payment/verify", payload);
    return data;
}

export async function testUnlock(analysis_id, token, consents = {}) {
    const { data } = await api.post("/payment/test-unlock", {
        analysis_id,
        token,
        ownership_consent: Boolean(consents.ownership_consent),
        ai_disclaimer_consent: Boolean(consents.ai_disclaimer_consent),
    });
    return data;
}

export async function saveStoryStudio(analysis_id, payload) {
    const { data } = await api.post(`/analysis/${analysis_id}/story-studio`, payload);
    return data;
}

export async function captureLead(email, source = "landing") {
    const { data } = await api.post("/lead", { email, source });
    return data;
}

export function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            // Strip the data URL prefix
            const base64 = String(result).split(",")[1] || String(result);
            resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export function loadRazorpayScript() {
    return new Promise((resolve) => {
        if (window.Razorpay) return resolve(true);
        const s = document.createElement("script");
        s.src = "https://checkout.razorpay.com/v1/checkout.js";
        s.onload = () => resolve(true);
        s.onerror = () => resolve(false);
        document.body.appendChild(s);
    });
}

